module.exports = __webpack_public_path__ + "r-v3/img/ico_block_white.b2da9697.svg";